import Header from '@/components/Header'
import Footer from '@/components/Footer'
import WhatsAppFloat from '@/components/WhatsAppFloat'
import Breadcrumb from '@/components/Breadcrumb'
import MetaTags from '@/components/MetaTags'

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <MetaTags
        title="Política de Privacidade - FotoLivro Store | LGPD"
        description="Leia nossa Política de Privacidade e entenda como a FotoLivro Store protege seus dados pessoais em conformidade com a LGPD (Lei Geral de Proteção de Dados)."
        type="website"
      />
      <Header />
      <Breadcrumb />
      <main className="flex-1 bg-background">
        <section className="py-20">
          <div className="container mx-auto px-4 max-w-4xl">
            <h1 className="text-4xl md:text-5xl font-bold text-center mb-8 text-foreground">
              Política de Privacidade
            </h1>

            <div className="prose prose-lg max-w-none text-foreground space-y-8">
              <section>
                <h2 className="text-2xl font-bold mb-4">1. Introdução</h2>
                <p className="text-muted-foreground leading-relaxed">
                  A Política de Privacidade de Dados Pessoais da PH Tecnologia
                  LTDA ("FotoLivroStore") foi criada para demonstrar o
                  compromisso com a segurança e a privacidade das informações
                  coletadas dos usuários, além de estabelecer regras sobre o
                  tratamento dos dados pessoais dentro do escopo dos serviços
                  prestados.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  A proteção dos seus dados é muito importante para a
                  FotoLivroStore; recomenda-se a leitura atenta deste documento.
                  Esta Política é aplicável a todo e qualquer serviço oferecido
                  pela FotoLivroStore. As informações dos usuários não serão
                  fornecidas, publicadas ou comercializadas em quaisquer
                  circunstâncias, exceto conforme previsto nesta Política. Esta
                  Política pode ser alterada sem aviso prévio, sendo as mudanças
                  divulgadas no mesmo local da versão anterior.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">2. Definições</h2>
                <dl className="space-y-4">
                  <div>
                    <dt className="font-semibold text-foreground">Usuário:</dt>
                    <dd className="text-muted-foreground">
                      Pessoa natural titular dos dados pessoais tratados pela
                      FotoLivroStore.
                    </dd>
                  </div>
                  <div>
                    <dt className="font-semibold text-foreground">
                      Fornecedores de dados indiretos:
                    </dt>
                    <dd className="text-muted-foreground">
                      Pessoa natural titular de dados pessoais tratados pelos
                      usuários da FotoLivroStore, que não façam parte de
                      eventual sociedade ou organização do usuário.
                    </dd>
                  </div>
                  <div>
                    <dt className="font-semibold text-foreground">
                      Dado pessoal:
                    </dt>
                    <dd className="text-muted-foreground">
                      Informação relacionada a pessoa natural identificada ou
                      identificável.
                    </dd>
                  </div>
                  <div>
                    <dt className="font-semibold text-foreground">
                      Dado pessoal sensível:
                    </dt>
                    <dd className="text-muted-foreground">
                      Dado pessoal sobre origem racial ou étnica, convicção
                      religiosa, opinião política, filiação a sindicato ou a
                      organização de caráter religioso, filosófico ou político,
                      dado referente à saúde ou à vida sexual, dado genético ou
                      biométrico, quando vinculado a uma pessoa natural.
                    </dd>
                  </div>
                  <div>
                    <dt className="font-semibold text-foreground">
                      Tratamento de dados:
                    </dt>
                    <dd className="text-muted-foreground">
                      Qualquer operação realizada com dados pessoais (coleta,
                      produção, recepção, classificação, utilização, acesso,
                      reprodução, transmissão, distribuição, processamento,
                      arquivamento, armazenamento, eliminação, avaliação ou
                      controle da informação, modificação, comunicação,
                      transferência, difusão ou extração).
                    </dd>
                  </div>
                  <div>
                    <dt className="font-semibold text-foreground">
                      Consentimento:
                    </dt>
                    <dd className="text-muted-foreground">
                      Manifestação livre, informada e inequívoca pela qual o
                      titular concorda com o tratamento de seus dados pessoais
                      para uma finalidade determinada.
                    </dd>
                  </div>
                  <div>
                    <dt className="font-semibold text-foreground">Cookies:</dt>
                    <dd className="text-muted-foreground">
                      Pequenos arquivos de texto gravados no dispositivo do
                      visitante e utilizados para identificar e armazenar
                      informações sobre a navegação.
                    </dd>
                  </div>
                </dl>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">
                  3. Agente de Tratamento
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Esta política é utilizada pela{' '}
                  <strong>PH Tecnologia LTDA</strong>, inscrita no CNPJ sob o nº{' '}
                  <strong>40.524.684/0001-45</strong>, com sede na Rua Imaculada
                  Conceição, 1430, Prado Velho, Curitiba/PR, CEP 80.215-182,
                  doravante denominada FotoLivroStore.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  A FotoLivroStore coleta e trata dados de seus clientes,
                  potenciais clientes e quaisquer pessoas físicas que a
                  contatem, respeitando os limites, finalidades e intenções
                  expostas neste documento.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">
                  4. Sobre os Dados que Coletamos
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Os dados, incluindo dados pessoais, poderão ser coletados
                  quando o usuário os submete voluntariamente ou quando interage
                  com os serviços da FotoLivroStore, para adequada prestação dos
                  serviços e demais finalidades desta Política.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  <strong>Dados pessoais tratados (exemplos):</strong> imagem
                  pessoal; nome completo; telefone; e-mail; endereço completo;
                  CPF; dados bancários.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  <strong>Dados sensíveis:</strong> não são coletados como
                  prática, salvo quando enviados espontaneamente pelo usuário
                  mediante consentimento expresso e inequívoco.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  <strong>Dados de crianças e adolescentes:</strong> somente
                  serão tratados com consentimento explícito dos responsáveis
                  legais.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">6. Cookies</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Para fins administrativos e de aprimoramento da experiência do
                  usuário, a FotoLivroStore poderá utilizar cookies durante a
                  navegação.
                </p>
                <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                  <li>
                    <strong>Cookies necessários:</strong> essenciais para o
                    funcionamento da plataforma
                  </li>
                  <li>
                    <strong>Cookies de terceiros:</strong> usados para análise
                    de desempenho e marketing
                  </li>
                  <li>
                    <strong>Cookies de preferências:</strong> lembram escolhas
                    do usuário
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">
                  8. Compartilhamento de Dados
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Exceto conforme disposto nesta Política, a FotoLivroStore não
                  compartilhará dados pessoais com terceiros sem consentimento
                  específico e informado. As informações poderão ser
                  compartilhadas com prestadores de serviços e parceiros
                  tecnológicos para armazenamento, hospedagem, processamento e
                  entrega de funcionalidades.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">
                  9. Segurança da Informação
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  A FotoLivroStore adota medidas técnicas e administrativas
                  aptas a proteger os dados pessoais contra acessos não
                  autorizados, perda, destruição ou alteração indevida.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  <strong>Central de Suporte:</strong>{' '}
                  <a
                    href="mailto:atendimento@fotolivro.store"
                    className="text-primary hover:underline"
                  >
                    atendimento@fotolivro.store
                  </a>
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">
                  10. Direitos dos Usuários
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  O usuário pode exercer, de forma gratuita, os direitos
                  previstos na LGPD: confirmação da existência de tratamento;
                  acesso; correção; anonimização, bloqueio ou eliminação;
                  portabilidade; informação sobre compartilhamentos; e revogação
                  do consentimento.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">
                  11. Período de Retenção
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Os dados são mantidos enquanto necessários para cumprir as
                  finalidades desta Política e/ou obrigações legais. Após o
                  término das relações contratuais, os dados poderão ser
                  mantidos pelo prazo legal aplicável (ex.: 5 anos) e, depois,
                  eliminados ou anonimizados.
                </p>
              </section>

              <section className="border-t pt-8 mt-8">
                <p className="text-muted-foreground text-center">
                  <strong>Curitiba, 10 de outubro de 2025.</strong>
                  <br />
                  PH Tecnologia LTDA – FotoLivroStore
                  <br />
                  CNPJ nº 40.524.684/0001-45
                </p>
              </section>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  )
}

export default PrivacyPolicy
